import { domainProvider } from '../../domain/domainProvider'

const S3URL = `https://frontend-assets.${domainProvider.TARGET_DOMAIN}`

const USER_UPLOADS_BUCKET = {
  live: 'https://mathflat-user-uploads.s3.ap-northeast-2.amazonaws.com',
  dev: 'https://mathflat-user-uploads-dev.s3.ap-northeast-2.amazonaws.com',
}

export const s3URL = {
  student(url: string) {
    return `${S3URL}/student/${url}`
  },
  teacher(url: string) {
    return `${S3URL}/teacher/${url}`
  },
  common(url: string) {
    return `${S3URL}/common/${url}`
  },
  homepage(url: string) {
    return `${S3URL}/homepage/${url}`
  },
  font(url: string) {
    return `${S3URL}/font/${url}`
  },
  mathflatAssetsBucket: {
    student(url: string) {
      return `${S3URL}/student/${url}`
    },
    teacher(url: string) {
      return `${S3URL}/teacher/${url}`
    },
    common(url: string) {
      return `${S3URL}/common/${url}`
    },
    font(url: string) {
      return `${S3URL}/font/${url}`
    },
    graphic(url: string) {
      return `${S3URL}/graphic/${url}`
    },
  },
  /** shared 는 실행 환경을 모르므로 live/dev 판단은 호출하는 앱의 envUtils 가 넘긴다 */
  mathflatUserUploadsBucket(url: string, { isLive }: { isLive: boolean }) {
    return `${USER_UPLOADS_BUCKET[isLive ? 'live' : 'dev']}/${url}`
  },
}
